<template>
  <div>
    <div class="side-frame">
      <span style="font-size: 14px; color: #606266"
        >订单编号：{{ formData.orderNo ? formData.orderNo : '--' }}</span
      >
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266"
        >运单编号：{{ formData.waybillNo ? formData.waybillNo : '--' }}</span
      >
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266"
        >状态：{{ formData.v_bizStatus ? formData.v_bizStatus : '--' }}</span
      >
    </div>
    <el-form ref="form" size="small" :model="formData" :rules="rules">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="'总收入重量(kg)'" prop="totInWeight">
            <el-input-number
              v-model="formData.totInWeight"
              controls-position="right"
              :min="0"
              :step="1"
              :precision="2"
              :placeholder="'请输入总收入重量'"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'总支出重量(kg)'" prop="totPayWeight">
            <el-input-number
              v-model="formData.totPayWeight"
              controls-position="right"
              :min="0"
              :step="1"
              :precision="2"
              :placeholder="'请输入总支出重量'"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="'总收入体积(m³)'" prop="totInVolume">
            <el-input-number
              v-model="formData.totInVolume"
              controls-position="right"
              :min="0"
              :step="1"
              :precision="2"
              :placeholder="'请输入总收入体积'"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'总支出体积(m³)'" prop="totPayVolume">
            <el-input-number
              v-model="formData.totPayVolume"
              controls-position="right"
              :min="0"
              :step="1"
              :precision="2"
              :placeholder="'请输入总支出体积'"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="'总件数'" prop="totQty">
            <el-input-number
              v-model="formData.totQty"
              controls-position="right"
              :min="0"
              :step="1"
              :precision="0"
              :placeholder="'请输入总件数'"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'总货值'" prop="totValue">
            <el-input-number
              v-model="formData.totValue"
              controls-position="right"
              :min="0"
              :step="1"
              :precision="4"
              :placeholder="'请输入货值'"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="side-frame-success">
      <span style="font-size: 14px; color: #606266"
        >订单创建时间：{{
          formData.orderCreateByName ? formData.orderCreateByName : '--'
        }}
        at {{ formData.orderCreateTime ? formData.orderCreateTime : '--' }}
      </span>
    </div>
    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    waybillDetailCode: {type: String, default: ''},
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      rules: {
        totQty: [{required: true, message: '请输入总件数', trigger: 'blur'}],
        totValue: [{required: true, message: '请输入总货值', trigger: 'blur'}],
        totInWeight: [
          {required: true, message: '请输入总收入重量', trigger: 'blur'},
        ],
        totInVolume: [
          {required: true, message: '请输入总收入体积', trigger: 'blur'},
        ],
        totPayWeight: [
          {required: true, message: '请输入总支出重量', trigger: 'blur'},
        ],
        totPayVolume: [
          {required: true, message: '请输入总支出体积', trigger: 'blur'},
        ],
      },
    }
  },
  watch: {},
  computed: {},
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.waybillDetailCode) return
      this.$api
        .carriageWaybillDetailDetailApi({
          waybillDetailCode: this.waybillDetailCode,
        })
        .then((res) => {
          this.formData = res.body
        })
        .catch(() => {})
    },
    async save() {
      const result = await this.validateData()
      if (!result) return
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .carriageWaybillDetailBackfillApi(this.formData)
        .then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          loadingInstance.close()
          this.$emit('reload')
          this.loadData()
          this.close()
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    async validateData() {
      const formResult = await validate.formValidate([this.$refs.form])
      return formResult
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.line {
  text-align: center;
}
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid $color-success;
  margin: 15px 0;
}
.group-title {
  font-size: 16px;
  font-weight: 500;
  color: #606266;
}
</style>
